import { motion } from "framer-motion"
import { graphql } from "gatsby"
import React from "react"
import Modal from "react-modal"
import ReactPlayer from "react-player"
import ImageOpt from "./ImageOpt"

const Banner = ({ module }) => {
  const animationVariants = {
    hidden: {
      opacity: 0,
      y: 20,
    },
    visible: {
      opacity: 1,
      y: 0,
    },
  }
  const [modalIsOpen, setIsOpen] = React.useState(false)
  function openModal(data) {
    document.body.classList.add("modal-open")
    setIsOpen(true)
  }
  function closeModal() {
    document.body.classList.remove("modal-open")
    setIsOpen(false)
  }
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0",
      border: "0",
      borderRadius: "0",
      width: "100%",
      height: "100%",
      backgroundColor: "black",
    },
    overlay: {
      zIndex: "99",
    },
  }
  if (module.hideSection === "no") {
    if (module?.bannerStyle === "full") {
      return (
        <section className="banner--wapper">
          <div
            className="h-[88px] smscreen2:h-[89px] opacity-0"
            aria-label="Kova"
          >
            Kove
          </div>
          <div
            className={`banner relative full-banner ${
              module.extraClass ? `${module.extraClass}` : ""
            }`}
            id={module.extraId}
          >
            <div className="container-fluid h-full">
              <div className="banner-inner relative h-full">
                {module?.bannerVideoFull && (
                  <div className="watch-video">
                    <button
                      className="outline-none flex"
                      onClick={() => {
                        openModal()
                      }}
                    >
                      <div className="icon-btn absolute z-[10] bottom-30 right-50per translate-x-[50%] flex items-center gap-x-1 hover:cursor-pointer group">
                        <img
                          className="w-[20px] h-[20px] object-contain group-hover:scale-[1.1] transition-all duration-75 ease-linear"
                          src="/images/play_circle.svg"
                          alt=""
                        />
                        <span className="icon-btn__text font-secondary text-[#ffffff] text-18 italic leading-[1em]">
                          Watch Full Video
                        </span>
                      </div>
                    </button>
                    <Modal
                      isOpen={modalIsOpen}
                      style={customStyles}
                      onRequestClose={closeModal}
                      contentLabel="story modal"
                      id="story-modal"
                    >
                      <div className="video-modal-popup h-full">
                        <button
                          onClick={closeModal}
                          className="absolute z-[40] right-60 mdscreen:right-20 top-60 mdscreen:top-20 bg-white flex items-center justify-center w-[40px] h-[40px] rounded-100"
                        >
                          <img
                            src="/images/close-white.svg"
                            alt="Close"
                            loading="lazy"
                            width={20}
                            height={20}
                          />
                        </button>
                        <div className="flex flex-wrap items-center h-full">
                          <div className="lg:w-12/12 w-full h-full">
                            <div className="modal-video h-full relative">
                              <ReactPlayer
                                className="modal-banner-video !w-full !h-full object-cover relative z-[30]"
                                loop={true}
                                playing={true}
                                controls={false}
                                url={module.bannerVideoFull.url}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal>
                  </div>
                )}
                <div className="desk-img h-full mdscreen:h-full relative ">
                  {module?.bannerVideo && (
                    <>
                      <video
                        loop
                        preload="auto"
                        playsInline="playsinline"
                        autoPlay="autoplay"
                        muted="muted"
                        style={{
                          width: `100%`,
                          objectFit: `cover`,
                          objectPosition: `top`,
                          height: `100%`,
                          position: `relative`,
                          zIndex: `2`,
                        }}
                      >
                        <source src={module.bannerVideo.url} type="video/mp4" />
                        <track kind="captions" />
                      </video>
                      {module.posterImageMobile ? (
                        <>
                          <ImageOpt
                            imgData={module.posterImage.mediaItemUrl}
                            width={1440}
                            height={768}
                            imgFetchPriority="high"
                            imgAlt={module.posterImage.altText}
                            imgLoad="eager"
                            imgClass="absolute top-0 left-0 z-[1] w-full h-full object-cover mdscreen:hidden"
                          />
                          <ImageOpt
                            imgData={module.posterImageMobile.mediaItemUrl}
                            width={480}
                            height={930}
                            imgFetchPriority="high"
                            imgAlt={module.posterImageMobile.altText}
                            imgLoad="eager"
                            imgClass="absolute top-0 left-0 z-[1] w-full h-full object-cover md:hidden"
                          />
                        </>
                      ) : (
                        <ImageOpt
                          imgData={module.posterImage.mediaItemUrl}
                          width={1440}
                          height={768}
                          imgFetchPriority="high"
                          imgAlt={module.posterImage.altText}
                          imgLoad="eager"
                          imgClass="absolute top-0 left-0 z-[1] w-full h-full object-cover"
                        />
                      )}
                    </>
                  )}
                </div>

                {(module?.bannerLogo || module?.heading) && (
                  <div className="banner-content w-full absolute top-50per left-50per translate-y-minus_50 translate-x-minus_50 z-10 mdscreen:px-10">
                    <motion.div
                      initial="hidden"
                      animate="visible"
                      variants={animationVariants}
                      transition={{ duration: 0.5, delay: 0.5 }}
                    >
                      <img
                        src={module.bannerLogo.mediaItemUrl}
                        width={404}
                        height={273}
                        loading="eager"
                        alt="Kove Collection"
                        className="mx-auto"
                      />
                    </motion.div>
                    {module?.heading && (
                      <div className="pt-60 text-center w-full">
                        <div className="title-white">
                          <motion.h1
                            initial="hidden"
                            animate="visible"
                            variants={animationVariants}
                            transition={{ duration: 0.5, delay: 1 }}
                          >
                            {module.heading}
                          </motion.h1>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {/* <div className="absolute bottom-0 pb-120 desktop_small:pb-100 lgscreen:!pb-[160px] mdscreen:!pb-100 z-10 text-center w-full px-30">
                  {module?.heading && (
                    <div className="title-white">
                      <motion.h1
                        initial="hidden"
                        animate="visible"
                        variants={animationVariants}
                        transition={{ duration: 0.5, delay: 1 }}
                      >
                        {module.heading}
                      </motion.h1>
                    </div>
                  )}
                </div> */}
              </div>
            </div>
          </div>
        </section>
      )
    } else {
      return (
        <section className="banner--wapper">
          <div
            className="h-[88px] smscreen2:h-[89px] opacity-0"
            aria-label="Kova"
          >
            Kove
          </div>
          <div
            className={`banner half-banner relative bg-stone ${
              module.extraClass ? `${module.extraClass}` : ""
            }`}
            id={module.extraId}
          >
            <div className="container-fluid h-full">
              <div className="banner-inner relative h-full">
                {module?.backgroundImage && (
                  <div className="desk-img h-full mdscreen:h-full relative block smscreen2:hidden">
                    <ImageOpt
                      imgData={module.backgroundImage.mediaItemUrl}
                      width={1440}
                      height={552}
                      imgAlt={module.backgroundImage.altText}
                      imgLoad="eager"
                      imgClass="w-full h-full object-cover"
                    />
                  </div>
                )}
                {module?.backgroundImageMobile && (
                  <div className="mobile-img h-full mdscreen:h-full relative hidden smscreen2:block">
                    <ImageOpt
                      imgData={module.backgroundImageMobile.mediaItemUrl}
                      width={1000}
                      height={700}
                      imgAlt={module.backgroundImageMobile.altText}
                      imgLoad="eager"
                      imgClass="w-full h-full object-cover"
                    />
                  </div>
                )}
                <div className="absolute bottom-0 pb-120 lgscreen:pb-50 z-10 text-center w-full px-30">
                  {module?.preHeading && (
                    <motion.div
                      initial="hidden"
                      animate="visible"
                      variants={animationVariants}
                      transition={{ duration: 0.5, delay: 0.5 }}
                      className="preheading mb-10 lgscreen:mb-15"
                    >
                      <span className="font-ositalic text-17 text-white-100 ">
                        {module.preHeading}
                      </span>
                    </motion.div>
                  )}
                  {module?.heading && (
                    <div className="title-white">
                      <motion.h1
                        initial="hidden"
                        animate="visible"
                        variants={animationVariants}
                        transition={{ duration: 0.5, delay: 1 }}
                      >
                        {module.heading}
                      </motion.h1>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    }
  }
}

export default Banner
export const PageBannerFragment = graphql`
  fragment PageBannerFragment on WpPage_Pagecontent_PageContent_Banner {
    extraId
    extraClass
    hideSection
    preHeading
    heading
    bannerStyle
    bannerLogo {
      altText
      mediaItemUrl
    }
    backgroundImageMobile {
      altText
      mediaItemUrl
    }
    backgroundImage {
      altText
      mediaItemUrl
    }
    bannerVideo {
      target
      title
      url
    }
    bannerVideoFull {
      target
      title
      url
    }
    posterImage {
      altText
      mediaItemUrl
    }
    posterImageMobile {
      altText
      mediaItemUrl
    }
  }
`
